import { notifyError } from '../../../helpers/utils';
import { SourceFileGroup } from '../../upload';
import { StyleValidationResult } from '../types';

export const generateCatalogTemplatesIdsList = (data: SourceFileGroup[]) => {
  return JSON.stringify(data.map((sectionItem: SourceFileGroup) => sectionItem.id));
};

export const generateTagsFieldOptions = (data: SourceFileGroup[]) => {
  return data.map((item) => ({
    label: item.name,
    value: item.id,
  }));
};

/**
 * Converts an array of StyleValidationResult objects into a CSV string.
 * @param data Array of validation results.
 * @returns A string formatted as CSV.
 */
export const convertToCSV = (data: StyleValidationResult[]): string => {
  if (!data || data.length === 0) {
    return '';
  }

  const headers = ['Location', 'Issue', 'Expected', 'Actual', 'Text', 'Current Style', 'Based On'];
  const rows = data.map((row) => {
    // Escape quotes by doubling them and enclose in quotes if necessary
    const escapeCSV = (field: string | undefined | null): string => {
      if (field === null || field === undefined) {
        return '';
      }
      const stringField = String(field);
      // Check if the field contains a comma, quote, or newline
      if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
        // Escape double quotes by doubling them
        const escapedField = stringField.replace(/"/g, '""');
        return `"${escapedField}"`;
      }
      return stringField;
    };

    let currentStyle = '';
    let basedOn = '';
    const elementStyles = row.elementStyles;

    if (elementStyles?.length) {
      currentStyle = elementStyles[elementStyles.length - 1];
      basedOn = elementStyles.slice(0, -1).join('->');
    }

    return [
      escapeCSV(row.location),
      escapeCSV(row.issue),
      escapeCSV(row.expected),
      escapeCSV(row.actual),
      escapeCSV(row.text),
      escapeCSV(currentStyle),
      escapeCSV(basedOn),
    ].join(',');
  });

  return [headers.join(','), ...rows].join('\n');
};

export const handleDownloadCSV = (validationResults: StyleValidationResult[]) => {
  if (validationResults.length === 0) {
    notifyError('No validation results to download.');
    return;
  }
  const csvData = convertToCSV(validationResults);
  const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'validation_results.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};
